import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { initSentry, Sentry } from './sentry'
import CrashScreen from './components/shared/CrashScreen'
import App from './App'
import './styles/index.css'

initSentry()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* Every render error that reaches this boundary is a Sentry event; the
        CrashScreen is what the operator sees instead of a white page. */}
    <Sentry.ErrorBoundary fallback={CrashScreen}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
